import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config';

export interface WorkoutProgramParams {
  user_id: string;
  user_name: string;
  body_weight: string | number;
  mobility_level: string;
  stability_level: string;
  balance_consistency: string;
  movement_symmetry: string;
  overall_movement_quality: string;
  program_name: string;
  program_length: number;
  workout_duration: string;
  fitness_level: string;
  energy_level: string;
  daily_physical_load: string;
  goals: string;
  training_goal: string;
  training_style: string;
  focused_area: string;
  muscles: string[];
  selected_days: string[];
  selected_time: string;
  workout_intensity: string;
  injured_body_parts: string;
  extra_info: string;
  equiptments: string[];
  activation_date: string;
  preferences: string;
  model: string;
}

export function useSummarizeInstruction() {
  return useMutation({
    mutationFn: async (params: WorkoutProgramParams) => {
      const response = await axios.post(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.SUMMARIZE_INSTRUCTION_API_HOST}`,
        { data: params }, // Firebase Callable functions expect payload inside 'data'
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      // Firebase Callable responses are wrapped inside 'result' or 'data'
      return response.data?.result || response.data?.data || response.data;
    },
  });
}

export const generateWorkoutProgramCoach = async (params: WorkoutProgramParams) => {
  const response = await axios.post(
    `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.GENERATE_WORKOUT_PROGRAM_COACH_API_HOST}`,
    { data: params },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 600000,
    },
  );
  return response.data?.result || response.data?.data || response.data;
};

export function useGenerateWorkoutProgram() {
  return useMutation({
    mutationFn: generateWorkoutProgramCoach,
  });
}
